/**
 * 根据传入的校验规则数组，依次调用，当某一条校验规则不满足时，停止校验并返回校验结果
 * @param validators 校验规则数组
 * @param validatorRunner 如何运行校验规则，并填充对应参数
 * @param runnerContext 运行校验规则时，this 指针指向
 */
export function runValidators(validators, validatorRunner, runnerContext) {
    if (runnerContext === void 0) { runnerContext = null; }
    var validatorResult;
    // 1. 如果传入一个空的数组作为校验规则，直接通过
    if (!validators.length)
        return VALIDATE_PASS_RESULT;
    // 2. 遍历校验规则，调用校验函数
    validators.every(function (validator) {
        // 调用校验函数，如果函数没有返回校验结果，则认为校验失败
        validatorResult = validatorRunner.call(runnerContext, validator) || EMPTY_VALIDATE_RESULT;
        return validatorResult.isValid;
    });
    // 返回校验结果
    return validatorResult;
}
/** 默认校验通过返回结果 */
export var VALIDATE_PASS_RESULT = {
    isValid: true,
    message: '',
};
export var EMPTY_VALIDATE_RESULT = {
    isValid: false,
    message: 'Validator does not return anything.',
};
